<template>
  <div class="the-footer">
    <small class="the-footer__copyright">聯合報 新聞部 著作權所有</small>
    <small class="the-footer__copyright">© udngroup.com All Rights Reserved.</small>
  </div>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>

<style lang="scss">
.the-footer {
  @include use-layer(&);
  padding: 40px 0;
  font: normal 100%/150% "Montserrat", "Noto Sans TC", sans-serif;
  text-align: center;

  &__copyright {
    display: block;
    color: #231815;
    font-size: 0.75em;
    line-break: 1.5em;
    @include rwd($RWD_TABLET_SMALL) {
      display: inline-block;
      font-size: 0.875em;
    }
    @include rwd($RWD_TABLET) {
      display: inline-block;
      font-size: 0.875em;
    }

    & + & {
      margin-top: 10px;
      @include rwd($RWD_TABLET_SMALL) {
        margin-top: 0;
        margin-left: 0.25em;
      }
    }
  }
}
</style>
